import { render } from "./FirstCarouselItem.vue?vue&type=template&id=a0764cfe&scoped=true"
import script from "./FirstCarouselItem.vue?vue&type=script&lang=js"
export * from "./FirstCarouselItem.vue?vue&type=script&lang=js"

import "./FirstCarouselItem.vue?vue&type=style&index=0&id=a0764cfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0764cfe"]])

export default __exports__